export default function MetaChip({ children, className = "" }) {
    return (
        <span
            className={`inline-block max-w-full whitespace-normal break-words rounded-full px-2.5 py-0.5 text-xs font-medium ${className}`}
        >
            {children}
        </span>
    );
}
